import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { appstore,googleplay,paymethod1,paymethod2,paymethod3,paymethod4,qrscan,logo,payment_methods } from '../../assets/img'
import { useDispatch, useSelector } from "react-redux";

export const SET_SETTINGS = "SET_SETTINGS";

export const setSettingsAll = (payload: any) => ({
  type: SET_SETTINGS,
  payload
});

function FooterTwo() {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const Url = window.location.host
  const blogUrl = `https://blog.${Url}`
  const [areaCovered, setAreaCovered] = useState<any | null>({})
  const [settings, setSettings] = useState<any>({});
  const jsonData: any = useSelector<any>((state) => state?.homeJsonList);

  const base_url = process.env.REACT_APP_BACKEND_URL;

  const settingsData: any = useSelector<any>(
    (state) => state?.settings
);

  var dateObj = new Date();
  var year = dateObj.getUTCFullYear();

  // useEffect(() => {
  //   if (Object.keys(settings).length === 0 && settingsData == undefined) {
  //     axios({
  //       method: "get",
  //       url: `${base_url}/api/settings`,
  //       headers: {
  //         "Accept": "application/json",
  //         'Access-Control-Allow-Methods': 'GET, POST',
  //       },
  //     }).then((response) => {
  //       if (response.status != 401) {
  //         setSettings(response.data.data);
  //         dispatch(setSettingsAll(response.data.data))
  //         let URL = window.location.href.split("/");
  //           if (!URL.includes("shop")) {
  //             const faviconLink = document.getElementById(
  //               "favicon"
  //             ) as HTMLLinkElement;
  //             if (faviconLink) {
  //               faviconLink.href = response.data.data.WebsiteSettings.logo_path +
  //               response.data.data.WebsiteSettings.style_fav
  //             } else {
  //               console.error("Favicon link element not found");
  //             }
  //           }
  //       }
  //     }).catch(function (error) {

  //     })
  //   }
  // }, [])

  useEffect(() => {
    let URL = window.location.href.split("/");
    if (!URL.includes("shop")) {
      const faviconLink = document.getElementById(
        "favicon"
      ) as HTMLLinkElement;
      if (faviconLink) {
        faviconLink.href = settingsData.WebsiteSettings.logo_path +
        settingsData.WebsiteSettings.style_fav
      } else {
        console.error("Favicon link element not found");
      }
    }
  }, []);


  return (
    <div>
      {jsonData && (
        <style type="text/css">
          {`
            :root {
              --footer-background: #${jsonData?.theme_2?.home?.footer?.bg_color};
              --footer-header: #${jsonData?.theme_2?.home?.footer?.section_heading_color};
              --footer-paragraph: #${jsonData?.theme_2?.home?.footer?.section_paragraph_color};
          }
          .footer {
            background: var(--footer-background) url(../img/home/footer-bg-temp-2.png) no-repeat;
            padding-top: 40px;
            color: #fff;
        }
          `}
        </style>
      )}
      <footer className="footer">
        <div className="container">
          
        <div className="row footer-sectiontwo">
            <div className="col-md-12">
              <div className='gr-border'>
              <div className="social-links gr-border-grid">
                    <div className="col-md footer-social text-center">
                      <ul className="list-inline">
                      {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.facebook
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        `https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.facebook?.facebook_link}`
                      }
                      target="_blank"
                    >
                      <i className="fab fa-facebook"></i>
                      Facebook
                    </a>
                  </li>
                )}
                {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.instagram
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        `https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.instagram?.instagram_link}`
                      }
                      target="_blank"
                    >
                      <i className="fab fa-instagram"></i>
                      Instagram
                    </a>
                  </li>
                )}
                {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.twitter
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        `https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.twitter?.twitter_link}`
                      }
                      target="_blank"
                    >
                      <i className="fab fa-twitter"></i>
                      Twitter
                    </a>
                  </li>
                )}
                {/* {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.whatsapp
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.whatsapp?.whatsapp_link
                      }
                      target="_blank"
                    >
                      <i className="fab fa-whatsapp"></i>
                      Whatsapp
                    </a>
                  </li>
                )} */}
                {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.linkedin
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        `https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.linkedin?.linkedin_link}`
                      }
                      target="_blank"
                    >
                      <i className="fab fa-linkedin"></i>
                      Linkedin
                    </a>
                  </li>
                )}
                {jsonData?.theme_2?.home?.footer?.footer_section?.social_media?.youtube
                  ?.is_enable && (
                  <li>
                    <a
                      href={
                        `https://${jsonData?.theme_2?.home?.footer?.footer_section?.social_media
                          ?.youtube?.youtube_link}`
                      }
                      target="_blank"
                    >
                      <i className="fab fa-youtube"></i>
                      Youtube
                    </a>
                  </li>
                )}
                        </ul>
                    </div>
              </div>
              </div>
            </div>
          </div>
          <div className="row footer-sectionthree">
            <div className="col-md col-sm-12">
              <h4>Explore</h4>
              <ul>
                {/* <li><a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#videomodal">How it works</a></li> */}
                <li><a href='/#services-section'>Services</a></li>
              </ul>
            </div>
            <div className="col-md col-sm-12">
              <h4>Our company</h4>
              <ul>
                <li><a href='' onClick={(e)=>{e.preventDefault(); navigate('/aboutUs')}}>About Us</a></li>
                <li><a target='_blank' href={blogUrl}>Blog</a></li>
                <li><a href='' onClick={(e)=>{e.preventDefault(); navigate('/areaCovered')}}>Locations</a></li>
                {/* <li><a href='' onClick={(e)=>{e.preventDefault(); navigate('/reviews')}}>Reviews</a></li> */}
              </ul>
            </div>
            <div className="col-md col-sm-12">
              <h4>Call Now for Services!</h4>
              <ul>
              {jsonData?.theme_2?.home?.footer?.mbl_number && (
                <li>
                  <a
                    href={`tel:${jsonData?.theme_2?.home?.footer?.mbl_number}`}
                  >
                    <i className="uil uil-phone-volume me-2"></i>
                    {jsonData?.theme_2?.home?.footer?.mbl_number}
                  </a>
                </li>
              )}
                {jsonData?.theme_2?.home?.footer?.email_val && (
                <li>
                  <a
                    href={`mailto:${jsonData?.theme_2?.home?.footer?.email_val}`}
                    className="primary-text"
                  >
                    <i className="uil uil-envelopes me-2"></i>
                    {jsonData?.theme_2?.home?.footer?.email_val}
                  </a>
                </li>    
                )}            
                <li>
                  <p style={{maxWidth:"250px",margin: "0 auto"}}>
                    {jsonData?.theme_2?.home?.footer?.address_val}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="row  footer-sectionfour">
            <div className="col-md-6 col-xs-12">
              <p className="footer-last">
                {Object.keys(settings).length > 0 && settings?.WebsiteSettings?.site_title_en} © {year}. All rights reserved. | Powered by &nbsp;<a href="http://www.bestatservices.com" target="blank">www.bestatservices.com</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default FooterTwo;